exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".live-desc[data-v-1be5721e]{margin-top:40px}h3[data-v-1be5721e]{font-size:18px;font-weight:700;line-height:1em;margin-bottom:23px}h3[data-v-1be5721e],pre[data-v-1be5721e]{color:#333}pre[data-v-1be5721e]{max-width:100%;font-family:inherit;white-space:pre-wrap;word-break:break-all;font-size:14px;line-height:28px}", ""]);

// exports
